"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __importDefault(require("../index"));
var node_fetch_1 = __importDefault(require("node-fetch"));
var ServerError_1 = __importDefault(require("../Errors/ServerError"));
var UnkownEnvironmentError_1 = __importDefault(require("../Errors/UnkownEnvironmentError"));
var NotSupportedEnvironmentError_1 = __importDefault(require("../Errors/NotSupportedEnvironmentError"));
function connector(service, method, resource, data, query) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, url, apiKeys, cookies, headers, props, env, response, _b, _c, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = index_1.default.getConfig(), url = _a.url, apiKeys = _a.apiKeys, cookies = _a.cookies;
                    headers = {
                        Accept: "application/json; charset=utf8",
                        "Content-Type": "application/json; charset=utf8",
                        "x-api-key": apiKeys[service],
                    };
                    //if cookies should handeld by sdk set cookies in header
                    if (cookies === "manual" && index_1.default.getCookieHeader())
                        headers.cookie = index_1.default.getCookieHeader();
                    props = {
                        method: method,
                        headers: headers,
                        body: method !== "GET" ? JSON.stringify(data) : undefined,
                    };
                    env = typeof process !== "undefined" &&
                        typeof process.versions === "object" &&
                        typeof process.versions.node !== "undefined"
                        ? "node"
                        : typeof window !== "undefined" || typeof self !== "undefined"
                            ? "browser"
                            : "unknown";
                    if (env === "unknown")
                        throw new UnkownEnvironmentError_1.default("We could not determin the used Environment.");
                    if (env === "browser" && typeof btoa === "undefined")
                        throw new NotSupportedEnvironmentError_1.default("Your Browser is not supported.");
                    if (!(env === "browser")) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("https://" +
                            service +
                            "." +
                            url +
                            resource +
                            ("?q=" + encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(query)))))), __assign({}, props, { mode: "cors", credentials: "include" }))];
                case 1:
                    _b = _d.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!(env === "node")) return [3 /*break*/, 4];
                    return [4 /*yield*/, node_fetch_1.default("https://" +
                            service +
                            "." +
                            url +
                            resource +
                            ("?q=" + encodeURIComponent(Buffer.from(JSON.stringify(query)).toString("base64"))), __assign({}, props, { referrerPolicy: "no-referrer", redirect: "follow", mode: "cors", cache: "no-cache", credentials: "include" }))];
                case 3:
                    _c = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _c = null;
                    _d.label = 5;
                case 5:
                    _b = _c;
                    _d.label = 6;
                case 6:
                    response = _b;
                    //if cookies are handeled by SDK check if they are set and save them
                    if (cookies === "manual" &&
                        Array.isArray(response.headers.raw()["set-cookie"])) {
                        response.headers.raw()["set-cookie"].forEach(function (cookie) {
                            index_1.default.addCookie(cookie.split("; ")[0]);
                        });
                    }
                    //return response and check for errors
                    if (response.status < 400) {
                        return [2 /*return*/, response.json()];
                    }
                    return [4 /*yield*/, response.json()];
                case 7:
                    error = _d.sent();
                    throw new ServerError_1.default(error.name || "", error.message || "", error.errors || null);
            }
        });
    });
}
function request(service, endpoint, query, projection, limit, sorting, next) {
    if (query === void 0) { query = {}; }
    if (projection === void 0) { projection = []; }
    if (limit === void 0) { limit = 1; }
    if (sorting === void 0) { sorting = null; }
    if (next === void 0) { next = null; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, resource;
        return __generator(this, function (_b) {
            _a = endpoint.split(" "), method = _a[0], resource = _a[1];
            return [2 /*return*/, connector(service, method, resource, {}, [
                    query,
                    projection,
                    limit,
                    sorting,
                    next,
                ])];
        });
    });
}
exports.request = request;
function send(service, endpoint, data, query, projection, limit) {
    if (data === void 0) { data = {}; }
    if (query === void 0) { query = {}; }
    if (projection === void 0) { projection = []; }
    if (limit === void 0) { limit = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, resource;
        return __generator(this, function (_b) {
            _a = endpoint.split(" "), method = _a[0], resource = _a[1];
            return [2 /*return*/, connector(service, method, resource, data, [query, projection, limit])];
        });
    });
}
exports.send = send;
